import { useEffect } from 'react';
import styles from './UpdatePhoto.module.scss'
import { deleteProductImage } from '../../../http/userAPI';

const PhotoItems = ({
  photos,
  setPhotos,
  productId
}) => {
  const handleRemovePhoto = async (photo) => {
    try {
      console.log('photo', photo);
      const newPhotos = photos.filter((currentPhoto) => currentPhoto !== photo)
      await deleteProductImage({ productId, image: photo })
      setPhotos(newPhotos)
    } catch (e) {
      console.error(e)
    }
  };

  useEffect(() => {
    console.log('photos', photos);
    photos.forEach(element => {

      console.log('element', element);
    });
  }, [photos])

  return (
    <>
      {photos.map((photo, index) => (
        <div key={index} className={styles.photoContainer}>
          <img src={photo} alt={`Фото ${index + 1}`} />
          {
            photos.length !== 1 ?
              <button
                type="button"
                className={styles.crossButton}
                onClick={() => handleRemovePhoto(photo)}
              >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className={styles.crossSvg}
                    d="M1.46484 8.53484L8.53684 1.46484M1.46484 1.46484L8.53684 8.53484"
                    stroke="black"
                    strokeWidth="1"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
              :
              <></>
          }

        </div>
      ))}
    </>
  );
};

export default PhotoItems;
